"use client";
import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

export type FilterType =
  | "all-upcoming"
  | "past-week"
  | "past-month"
  | "past-2-months"
  | "this-week"
  | "next-month"
  | "next-2-months";

const FILTER_OPTIONS: { label: string; value: FilterType }[] = [
  { label: "All Upcoming Events", value: "all-upcoming" },
  { label: "Past week", value: "past-week" },
  { label: "Past month", value: "past-month" },
  { label: "Past 2 months", value: "past-2-months" },
  { label: "This week", value: "this-week" },
  { label: "Next month", value: "next-month" },
  { label: "Next 2 months", value: "next-2-months" },
];

type EventFilterProps = {
  selected: FilterType;
  onChange: (filter: FilterType) => void;
};

const EventFilter = ({ selected, onChange }: EventFilterProps) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="text-base flex items-center gap-x-3 border border-[#00000033] px-3 py-2.5 rounded-lg hover:bg-gray-50 transition"
      >
        <span>
          {FILTER_OPTIONS.find((option) => option.value === selected)?.label}
        </span>
        <ChevronDown
          className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="absolute mt-2 w-56 bg-white border border-[#00000033] rounded-lg shadow-lg overflow-hidden z-10">
          {FILTER_OPTIONS.map((option) => (
            <button
              key={option.value}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
              className={`block w-full text-left px-4 py-2.5 text-sm hover:bg-gray-100 transition ${
                option.value === selected ? "bg-gray-50 font-medium" : ""
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EventFilter;
